import React, { useRef, useState } from "react";
import { Button, Tooltip, Overlay } from "react-bootstrap";

const ButtonImage = ({ className, buttonImage, tooltipImage, onClick, disabled }) => {
  const target = useRef(null);
  const [showTootip, setShowTooltip] = useState(false);

  return (
    <>
      <span ref={target} onPointerEnter={() => setShowTooltip(true)} onPointerLeave={() => setShowTooltip(false)}>
        <Button variant="bg-transparent" className={className} onClick={onClick} disabled={disabled}>
          {buttonImage}
        </Button>
      </span>
      <Overlay target={target.current} show={showTootip} placement="top">
        <Tooltip>{tooltipImage}</Tooltip>
      </Overlay>
    </>
  );
};

export default ButtonImage;
